import { isEmpty } from 'lodash-es';
import { map, pipe } from 'remeda';
import { type Descendant } from 'slate';

import { type UnityState } from '@@editor/typings/UnityElements';
import addDefaultElementIfEmptyState from '@@editor/utils/addDefaultElementIfEmptyState';

import { type Next } from '../../types';
import unwrapSerializedState from '../../unwrapSerializedState';
import wrapSerializedState from '../../wrapSerializedState';

export const createSerializedStateIfEmpty = (value) => {
    if (isEmpty(value)) {
        return wrapSerializedState(addDefaultElementIfEmptyState([]));
    }

    return value;
};

const deserializeCaption = (next: Next<Descendant>) => (caption: UnityState) =>
    pipe(
        caption,
        createSerializedStateIfEmpty,
        unwrapSerializedState,
        addDefaultElementIfEmptyState,
        map(next),
    );

export default deserializeCaption;
